import * as ActionTypes from '../action-types'

export function showAlert(title, message){
    return {
        type: ActionTypes.SHOW_ERROR_MESSAGE,
        payload: {
            title, message
        }
    }
}

export function hideAlert(){
    return {
        type: ActionTypes.HIDE_ERROR_MESSAGE,
    }
}
export function showSuccessAlert(title, message){
    return {
        type: ActionTypes.SHOW_SUCCESS_MESSAGE,
        payload: {
            title, message
        }
    }
}

export function hideSuccessAlert(){
    return {
        type: ActionTypes.HIDE_SUCCESS_MESSAGE,
    }
}

export function setTariffs(payload){
    return {
        type:ActionTypes.SET_TARIFFS,
        payload
    }
}

